import {CALL_API} from 'middleware/api';
import * as Actions from '../index';

function fetchToken() {
    return {
        type: Actions.FETCH_BETGAMES_TOKEN,
        [CALL_API]: {
            endpoint: '/api/betgames/',
            method: 'get',
            types: [Actions.SUCCESS_FETCH_BETGAMES_TOKEN, Actions.FAILURE_FETCH_BETGAMES_TOKEN],
            credentials: true
        }
    };
}

export function getToken() {
    return (dispatch) => {
        dispatch(fetchToken());
    };
}


// WEBPACK FOOTER //
// ./js/actions/betGames/creators/index.js